import type { JobNotification } from './types';

/** Toasts for a report queued for download: a persistent one linking to the stored report, or a failure. */
export const queuedDownloadNotification = (reportName: string, reportId: string): JobNotification => ({
  success: {
    content: `Your ${reportName} is ready to download.`,
    persistent: true,
    link: { text: 'Download', href: `/attribution/${reportId}?download=true` },
  },
  failure: { content: `Couldn't generate your ${reportName}. Please try again.` },
});
